'use client'
import { useContext } from 'react'

import { FirebaseUserContext } from './FirebaseUserContextProvider'

export const useFirebaseUser = () => {
  return useContext(FirebaseUserContext)
}
